import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from "@angular/router";

import { ClientService } from "../../services/client.service";
import { LoginService } from "../../services/login.service";
import { IPerson } from "../../model/person";
import { emptyClient, IClient } from "../../model/client";

declare const tl: any;

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css']
})
export class ClientComponent implements OnInit, OnDestroy {

  /**
   *
   * @type {boolean}
   */
  isDataLoaded: boolean = true;

  /**
   *
   * @type {IClient}
   */
  client: IClient = emptyClient;

  constructor(
    private loginService: LoginService,
    private clientService: ClientService,
    private router: Router,
  ) { }

  ngOnInit() {
   tl.pg.init({ steps_element: "#tlyPageGuideCLIENTES" });

    this.clientService.getClient(this.getPerson().identifier)
      .subscribe(
        res => {
          this.isDataLoaded = true;
          this.client = res;
        },
        error => {
          this.isDataLoaded = true;
          this.router.navigate(['/cliente/nuevo-cliente']);
        });
  }

  ngOnDestroy() {
    tl.pg.closeOpenGuides();
    tl.pg.destroy('#tlyPageGuideCLIENTES');
  }


  /**
   *
   * @return {IPerson}
   */
  private getPerson(): IPerson
  {
    return this.loginService.getPerson();
  }

}



// WEBPACK FOOTER //
// ./src/app/app-manager/client/client.component.ts